{
  "id": "discord.com",
  "version": 2,
  "name": "Discord",
  "author": "SR",
  "date": "2023-05-31",
  "url": "https://www.discord.com",
  "strings": {
    "en": {
      "name": "Discord",
      "help": [
        "Open the Discord App",
        "(Log in with your Discord Account)",
        "Open User Settings",
        "Then select the second entry 'Privacy and Safety'",
        "At the bottom click on 'Request Data' button",
        "Wait for the follow-up email and follow the instructions (can take up to 30 days)"
      ]
    },
    "de": {
      "name": "Discord",
      "help": [
        "Öffne die Discord App",
        "(Melde dich an)",
        "Öffne die Benutzereinstellungen (Zahnrad-Symbol unten links)",
        "Wähle den zweiten Eintrag 'Privatsphäre & Sicherheit' aus",
        "Ganz unten, Klicke auf 'Alle gesammelten Daten anfordern'.",
        "Überprüfen deine Email um die Anfrage zu bestätigen",
        "Du erhälst eine Email zum Herunterladen in etwa 1-5 Tagen"
      ]
    }
  },
  "instructions": [
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "factor": 0.000001 }
                }
              }
            ],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "ID": [
                            {
                              "type": "string"
                            }
                          ],
                          "Timestamp": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": {
                                  "pattern": "%Y-%m-%d %H:%M:%S.%f%Z"
                                }
                              }
                            }
                          ],
                          "Contents": [{ "type": "string" }, { "type": "empty" }],
                          "Attachments": [
                            {
                              "type": "string"
                            }
                          ],
                          "__parsed_extra": [
                            {
                              "type": "array",
                              "anyOf": [{ "type": "string" }]
                            },
                            { "type": "empty" }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Messages",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null, null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Timestamp"],
              "arguments": { "pattern": "%Y-%m-%d %H:%M:%S.%f%Z" },
              "template": ["data"]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "factor": 0.000001 }
                }
              }
            ],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        }
                      ],
                      "type": [{ "type": "number" }, { "type": "empty" }],
                      "recipients": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "name": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "iso": true }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "guild": [
                        {
                          "type": "object",
                          "properties": {
                            "id": [
                              {
                                "type": "string",
                                "supposedUsage": {
                                  "format": "time",
                                  "argument": { "factor": 0.000001 }
                                }
                              }
                            ],
                            "name": [
                              {
                                "type": "string",
                                "supposedUsage": {
                                  "format": "time",
                                  "argument": { "iso": true }
                                }
                              }
                            ]
                          }
                        },
                        { "type": "empty" }
                      ],
                      "username": [{ "type": "string" }, { "type": "empty" }],
                      "discriminator": [{ "type": "number" }, { "type": "empty" }],
                      "email": [{ "type": "string" }, { "type": "empty" }],
                      "verified": [{ "type": "boolean" }, { "type": "empty" }],
                      "avatar_hash": [{ "type": "string" }, { "type": "empty" }],
                      "has_mobile": [{ "type": "boolean" }, { "type": "empty" }],
                      "needs_email_verification": [{ "type": "boolean" }, { "type": "empty" }],
                      "premium_until": [{ "type": "empty" }],
                      "flags": [{ "type": "number" }, { "type": "empty" }],
                      "phone": [{ "type": "empty" }],
                      "temp_banned_until": [{ "type": "empty" }],
                      "ip": [{ "type": "string" }, { "type": "empty" }],
                      "settings": [
                        {
                          "type": "object",
                          "properties": {
                            "locale": [{ "type": "string" }],
                            "show_current_game": [{ "type": "boolean" }],
                            "restricted_guilds": [{ "type": "array", "anyOf": [] }],
                            "default_guilds_restricted": [{ "type": "boolean" }],
                            "inline_attachment_media": [{ "type": "boolean" }],
                            "inline_embed_media": [{ "type": "boolean" }],
                            "gif_auto_play": [{ "type": "boolean" }],
                            "render_embeds": [{ "type": "boolean" }],
                            "render_reactions": [{ "type": "boolean" }],
                            "animate_emoji": [{ "type": "boolean" }],
                            "enable_tts_command": [{ "type": "boolean" }],
                            "message_display_compact": [{ "type": "boolean" }],
                            "convert_emoticons": [{ "type": "boolean" }],
                            "explicit_content_filter": [{ "type": "number" }, { "type": "empty" }],
                            "disable_games_tab": [{ "type": "boolean" }],
                            "theme": [{ "type": "string" }],
                            "developer_mode": [{ "type": "boolean" }],
                            "guild_positions": [{ "type": "array", "anyOf": [] }],
                            "detect_platform_accounts": [{ "type": "boolean" }],
                            "status": [{ "type": "string" }],
                            "afk_timeout": [{ "type": "number" }],
                            "timezone_offset": [{ "type": "number" }],
                            "stream_notifications_enabled": [{ "type": "boolean" }],
                            "allow_accessibility_detection": [{ "type": "boolean" }],
                            "contact_sync_enabled": [{ "type": "boolean" }],
                            "native_phone_integration_enabled": [{ "type": "boolean" }],
                            "animate_stickers": [{ "type": "number" }, { "type": "empty" }],
                            "friend_discovery_flags": [{ "type": "number" }, { "type": "empty" }],
                            "friend_source_flags": [
                              {
                                "type": "object",
                                "properties": { "all": [{ "type": "boolean" }] }
                              }
                            ],
                            "guild_folders": [{ "type": "array", "anyOf": [] }],
                            "custom_status": [{ "type": "empty" }]
                          }
                        },
                        { "type": "empty" }
                      ],
                      "connections": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "external_friends_lists": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "friend_suggestions": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "mfa_sessions": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "relationships": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "id": [
                                  {
                                    "type": "string",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 0.000001 }
                                    }
                                  }
                                ],
                                "type": [{ "type": "number" }],
                                "nickname": [{ "type": "empty" }],
                                "user": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "id": [
                                        {
                                          "type": "string",
                                          "supposedUsage": {
                                            "format": "time",
                                            "argument": { "factor": 0.000001 }
                                          }
                                        }
                                      ],
                                      "username": [{ "type": "string" }],
                                      "avatar": [{ "type": "string" }, { "type": "empty" }],
                                      "discriminator": [{ "type": "string" }],
                                      "public_flags": [{ "type": "number" }, { "type": "empty" }]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "payments": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "payment_sources": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "guild_settings": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "guild_id": [
                                  {
                                    "type": "string",
                                    "supposedUsage": {
                                      "format": "time",
                                      "argument": { "factor": 0.000001 }
                                    }
                                  }
                                ],
                                "suppress_everyone": [{ "type": "boolean" }],
                                "suppress_roles": [{ "type": "boolean" }],
                                "message_notifications": [{ "type": "number" }],
                                "mobile_push": [{ "type": "boolean" }],
                                "muted": [{ "type": "boolean" }],
                                "mute_config": [
                                  { "type": "empty" },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "end_time": [{ "type": "empty" }],
                                      "selected_time_window": [{ "type": "number" }]
                                    }
                                  }
                                ],
                                "hide_muted_channels": [{ "type": "boolean" }],
                                "channel_overrides": [
                                  {
                                    "type": "array",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "channel_id": [
                                            {
                                              "type": "string",
                                              "supposedUsage": {
                                                "format": "time",
                                                "argument": {
                                                  "factor": 0.000001
                                                }
                                              }
                                            }
                                          ],
                                          "message_notifications": [{ "type": "number" }],
                                          "muted": [{ "type": "boolean" }],
                                          "mute_config": [
                                            {
                                              "type": "object",
                                              "properties": {
                                                "end_time": [{ "type": "empty" }],
                                                "selected_time_window": [{ "type": "number" }]
                                              }
                                            },
                                            { "type": "empty" }
                                          ],
                                          "collapsed": [{ "type": "boolean" }]
                                        }
                                      }
                                    ]
                                  }
                                ],
                                "version": [{ "type": "number" }]
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "library_applications": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "entitlements": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "user_activity_application_statistics": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "notes": [{ "type": "object", "properties": {} }, { "type": "empty" }],
                      "description": [{ "type": "empty" }],
                      "icon_hash": [{ "type": "string" }, { "type": "empty" }],
                      "splash_hash": [{ "type": "empty" }],
                      "banner_hash": [{ "type": "empty" }],
                      "owner_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "application_id": [{ "type": "empty" }],
                      "emoji_rev": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "region": [{ "type": "string" }, { "type": "empty" }],
                      "afk_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "afk_timeout": [{ "type": "number" }, { "type": "empty" }],
                      "system_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "widget_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "widget_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "verification_level": [{ "type": "number" }, { "type": "empty" }],
                      "features": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "default_message_notifications": [{ "type": "number" }, { "type": "empty" }],
                      "mfa_level": [{ "type": "number" }, { "type": "empty" }],
                      "max_presences": [{ "type": "empty" }],
                      "max_members": [{ "type": "number" }, { "type": "empty" }],
                      "vanity_url_code": [{ "type": "empty" }],
                      "explicit_content_filter": [{ "type": "number" }, { "type": "empty" }],
                      "system_channel_flags": [{ "type": "number" }, { "type": "empty" }],
                      "preferred_locale": [{ "type": "string" }, { "type": "empty" }],
                      "discovery_splash_hash": [{ "type": "empty" }],
                      "rules_channel_id": [{ "type": "empty" }],
                      "public_updates_channel_id": [{ "type": "empty" }],
                      "roles": [
                        {
                          "type": "object",
                          "properties": {
                            "824679324392095754": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }, { "type": "empty" }],
                                  "color": [{ "type": "number" }, { "type": "empty" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824679882159030284": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824679886077165610": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }, { "type": "empty" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824679888102621195": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824679889563025460": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }, { "type": "empty" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824679890460475423": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }, { "type": "empty" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824680043690197013": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }, { "type": "empty" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ],
                            "824680072232697899": [
                              {
                                "type": "object",
                                "properties": {
                                  "id": [
                                    {
                                      "type": "string",
                                      "supposedUsage": {
                                        "format": "time",
                                        "argument": { "factor": 0.000001 }
                                      }
                                    }
                                  ],
                                  "name": [{ "type": "string" }],
                                  "permissions": [{ "type": "string" }],
                                  "position": [{ "type": "number" }],
                                  "color": [{ "type": "number" }, { "type": "empty" }],
                                  "hoist": [{ "type": "boolean" }],
                                  "managed": [{ "type": "boolean" }],
                                  "mentionable": [{ "type": "boolean" }]
                                }
                              }
                            ]
                          }
                        },
                        { "type": "empty" }
                      ],
                      "custom_regions": [{ "type": "object", "properties": {} }, { "type": "empty" }]
                    }
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "712650124999917609": [{ "type": "string" }],
                      "711889279214682133": [{ "type": "string" }],
                      "712213427640336447": [{ "type": "string" }],
                      "602440516986208258": [{ "type": "empty" }],
                      "710097528519131240": [{ "type": "string" }],
                      "767561678773682238": [{ "type": "string" }]
                    }
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "event_type": [{ "type": "string" }],
                      "event_id": [{ "type": "string" }],
                      "event_source": [{ "type": "string" }],
                      "user_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        }
                      ],
                      "domain": [{ "type": "string" }],
                      "client_uuid": [{ "type": "string" }, { "type": "empty" }],
                      "freight_hostname": [{ "type": "string" }],
                      "freight_id": [{ "type": "string" }, { "type": "empty" }],
                      "ip": [{ "type": "string" }, { "type": "empty" }],
                      "day": [{ "type": "string" }],
                      "chosen_locale": [{ "type": "string" }, { "type": "empty" }],
                      "detected_locale": [{ "type": "string" }, { "type": "empty" }],
                      "user_is_authenticated": [{ "type": "boolean" }],
                      "browser": [{ "type": "string" }, { "type": "empty" }],
                      "cfduid": [{ "type": "string" }, { "type": "empty" }],
                      "os": [{ "type": "string" }, { "type": "empty" }],
                      "os_version": [{ "type": "string" }, { "type": "empty" }],
                      "os_arch": [{ "type": "string" }, { "type": "empty" }],
                      "client_build_number": [{ "type": "string" }, { "type": "empty" }],
                      "release_channel": [{ "type": "string" }, { "type": "empty" }],
                      "client_version": [{ "type": "string" }, { "type": "empty" }],
                      "client_performance_cpu": [{ "type": "number" }, { "type": "empty" }],
                      "client_performance_memory": [{ "type": "string" }, { "type": "empty" }],
                      "city": [{ "type": "string" }, { "type": "empty" }],
                      "country_code": [{ "type": "string" }, { "type": "empty" }],
                      "region_code": [{ "type": "string" }, { "type": "empty" }],
                      "time_zone": [{ "type": "string" }, { "type": "empty" }],
                      "isp": [{ "type": "string" }, { "type": "empty" }],
                      "guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "guild_size_total": [{ "type": "string" }, { "type": "empty" }],
                      "guild_member_num_roles": [{ "type": "string" }, { "type": "empty" }],
                      "guild_member_perms": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 1000 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "guild_num_channels": [{ "type": "string" }, { "type": "empty" }],
                      "guild_num_text_channels": [{ "type": "string" }, { "type": "empty" }],
                      "guild_num_voice_channels": [{ "type": "string" }, { "type": "empty" }],
                      "guild_num_roles": [{ "type": "string" }, { "type": "empty" }],
                      "guild_is_vip": [{ "type": "boolean" }, { "type": "empty" }],
                      "is_member": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_voice_channels_active": [{ "type": "string" }, { "type": "empty" }],
                      "channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "channel_type": [{ "type": "string" }, { "type": "empty" }],
                      "channel_size_total": [{ "type": "string" }, { "type": "empty" }],
                      "channel_member_perms": [{ "type": "string" }, { "type": "empty" }],
                      "channel_hidden": [{ "type": "boolean" }, { "type": "empty" }],
                      "accessibility_support_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "accessibility_features": [{ "type": "string" }, { "type": "empty" }],
                      "channel_is_nsfw": [{ "type": "boolean" }, { "type": "empty" }],
                      "system_locale": [{ "type": "string" }, { "type": "empty" }],
                      "client_send_timestamp": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "lang": "en" }
                          }
                        }
                      ],
                      "client_track_timestamp": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "lang": "en" }
                          }
                        }
                      ],
                      "timestamp": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "lang": "en" }
                          }
                        }
                      ],
                      "location_section": [{ "type": "string" }, { "type": "empty" }],
                      "message_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "channel": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "is_friend": [{ "type": "boolean" }, { "type": "empty" }],
                      "private": [{ "type": "boolean" }, { "type": "empty" }],
                      "server": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "num_attachments": [{ "type": "string" }, { "type": "empty" }],
                      "max_attachment_size": [{ "type": "string" }, { "type": "empty" }],
                      "length": [{ "type": "string" }, { "type": "empty" }],
                      "word_count": [{ "type": "string" }, { "type": "empty" }],
                      "mention_everyone": [{ "type": "boolean" }, { "type": "empty" }],
                      "emoji_unicode": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_custom": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_custom_external": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_managed": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_managed_external": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_animated": [{ "type": "string" }, { "type": "empty" }, { "type": "boolean" }],
                      "emoji_only": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_embeds": [{ "type": "string" }, { "type": "empty" }],
                      "attachment_ids": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "has_spoiler": [{ "type": "boolean" }, { "type": "empty" }],
                      "probably_has_markdown": [{ "type": "boolean" }, { "type": "empty" }],
                      "user_is_bot": [{ "type": "boolean" }, { "type": "empty" }],
                      "sticker_ids": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "message_type": [{ "type": "string" }, { "type": "empty" }],
                      "type": [{ "type": "string" }, { "type": "empty" }],
                      "has_images": [{ "type": "boolean" }, { "type": "empty" }],
                      "profile_user_status": [{ "type": "string" }, { "type": "empty" }],
                      "is_streaming": [{ "type": "boolean" }, { "type": "empty" }],
                      "has_custom_status": [{ "type": "boolean" }, { "type": "empty" }],
                      "location_object": [{ "type": "string" }, { "type": "empty" }],
                      "location": [{ "type": "string" }, { "type": "empty" }],
                      "join_method": [{ "type": "string" }, { "type": "empty" }],
                      "guild_name": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "iso": true }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "user_guilds": [{ "type": "string" }, { "type": "empty" }],
                      "join_type": [{ "type": "string" }, { "type": "empty" }],
                      "location_guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "location_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "location_channel_type": [{ "type": "string" }, { "type": "empty" }],
                      "application_name": [{ "type": "string" }, { "type": "empty" }],
                      "party_id": [{ "type": "string" }, { "type": "empty" }],
                      "party_platform": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_wifi": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_cellular": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_ethernet": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_bluetooth": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_other": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_unknown": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connection_type_none": [{ "type": "string" }, { "type": "empty" }],
                      "duration_effective_connection_speed_2g": [{ "type": "string" }, { "type": "empty" }],
                      "duration_effective_connection_speed_3g": [{ "type": "string" }, { "type": "empty" }],
                      "duration_effective_connection_speed_4g": [{ "type": "string" }, { "type": "empty" }],
                      "duration_effective_connection_speed_unknown": [{ "type": "string" }, { "type": "empty" }],
                      "media_session_id": [{ "type": "string" }, { "type": "empty" }],
                      "hostname": [{ "type": "string" }, { "type": "empty" }],
                      "port": [{ "type": "string" }, { "type": "empty" }],
                      "protocol": [{ "type": "string" }, { "type": "empty" }],
                      "reconnect": [{ "type": "boolean" }, { "type": "empty" }],
                      "reason": [{ "type": "string" }, { "type": "empty" }],
                      "duration": [{ "type": "string" }, { "type": "empty" }],
                      "rtc_connection_id": [{ "type": "string" }, { "type": "empty" }],
                      "channel_bitrate": [{ "type": "string" }, { "type": "empty" }],
                      "context": [{ "type": "string" }, { "type": "empty" }],
                      "connect_count": [{ "type": "string" }, { "type": "empty" }],
                      "packets_sent": [{ "type": "string" }, { "type": "empty" }],
                      "packets_sent_lost": [{ "type": "string" }, { "type": "empty" }],
                      "ping_average": [{ "type": "string" }, { "type": "empty" }],
                      "ping_bad_count": [{ "type": "string" }, { "type": "empty" }],
                      "ping_timeout": [{ "type": "string" }, { "type": "empty" }],
                      "packets_received": [{ "type": "string" }, { "type": "empty" }],
                      "packets_received_lost": [{ "type": "string" }, { "type": "empty" }],
                      "input_detected": [{ "type": "boolean" }, { "type": "empty" }],
                      "no_input_detected_notice": [{ "type": "boolean" }, { "type": "empty" }],
                      "audio_jitter_buffer_mean": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_buffer_p75": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_buffer_p95": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_buffer_p99": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_buffer_max": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_delay_mean": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_delay_p75": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_delay_p95": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_delay_p99": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_delay_max": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_target_mean": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_target_p75": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_target_p95": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_target_p99": [{ "type": "string" }, { "type": "empty" }],
                      "audio_jitter_target_max": [{ "type": "string" }, { "type": "empty" }],
                      "relative_reception_delay_mean": [{ "type": "string" }, { "type": "empty" }],
                      "relative_reception_delay_p75": [{ "type": "string" }, { "type": "empty" }],
                      "relative_reception_delay_p95": [{ "type": "string" }, { "type": "empty" }],
                      "relative_reception_delay_p99": [{ "type": "string" }, { "type": "empty" }],
                      "relative_reception_delay_max": [{ "type": "string" }, { "type": "empty" }],
                      "relative_playout_delay_mean": [{ "type": "string" }, { "type": "empty" }],
                      "relative_playout_delay_p75": [{ "type": "string" }, { "type": "empty" }],
                      "relative_playout_delay_p95": [{ "type": "string" }, { "type": "empty" }],
                      "relative_playout_delay_p99": [{ "type": "string" }, { "type": "empty" }],
                      "relative_playout_delay_max": [{ "type": "string" }, { "type": "empty" }],
                      "mos_mean": [{ "type": "number" }, { "type": "empty" }],
                      "mos_1": [{ "type": "string" }, { "type": "empty" }],
                      "mos_2": [{ "type": "string" }, { "type": "empty" }],
                      "mos_3": [{ "type": "string" }, { "type": "empty" }],
                      "mos_4": [{ "type": "string" }, { "type": "empty" }],
                      "audio_input_mode": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_silent": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_normal": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_merged": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_expanded": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_accelerated": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_preemptive_expanded": [{ "type": "string" }, { "type": "empty" }],
                      "frame_op_cng": [{ "type": "string" }, { "type": "empty" }],
                      "automatic_audio_input_sensitivity_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "audio_input_sensitivity": [{ "type": "number" }, { "type": "empty" }],
                      "echo_cancellation_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "noise_suppression_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "automatic_gain_control_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "voice_output_volume": [{ "type": "number" }, { "type": "empty" }],
                      "max_voice_state_count": [{ "type": "string" }, { "type": "empty" }],
                      "duration_listening": [{ "type": "string" }, { "type": "empty" }],
                      "duration_speaking": [{ "type": "string" }, { "type": "empty" }],
                      "duration_participation": [{ "type": "string" }, { "type": "empty" }],
                      "duration_connected": [{ "type": "string" }, { "type": "empty" }],
                      "noise_cancellation_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "cloudflare_best_region": [{ "type": "string" }, { "type": "empty" }],
                      "decryption_failures": [{ "type": "string" }, { "type": "empty" }],
                      "encryption_mode": [{ "type": "string" }, { "type": "empty" }],
                      "channel_count": [{ "type": "string" }, { "type": "empty" }],
                      "guild_template_code": [{ "type": "string" }, { "type": "empty" }],
                      "guild_template_name": [{ "type": "string" }, { "type": "empty" }],
                      "guild_template_guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "browser_user_agent": [{ "type": "string" }, { "type": "empty" }],
                      "browser_version": [{ "type": "string" }, { "type": "empty" }],
                      "referrer": [{ "type": "string" }, { "type": "empty" }],
                      "referring_domain": [{ "type": "string" }, { "type": "empty" }],
                      "location_page": [{ "type": "string" }, { "type": "empty" }],
                      "sku_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "subscription_plan_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "payment_type": [{ "type": "string" }, { "type": "empty" }],
                      "load_id": [{ "type": "string" }, { "type": "empty" }],
                      "quantity": [{ "type": "string" }, { "type": "empty" }],
                      "old_name": [{ "type": "string" }, { "type": "empty" }],
                      "new_name": [{ "type": "string" }, { "type": "empty" }],
                      "old_nsfw": [{ "type": "boolean" }, { "type": "empty" }],
                      "new_nsfw": [{ "type": "boolean" }, { "type": "empty" }],
                      "convert_emoticons": [{ "type": "boolean" }, { "type": "empty" }],
                      "developer_mode": [{ "type": "boolean" }, { "type": "empty" }],
                      "enable_tts_command": [{ "type": "boolean" }, { "type": "empty" }],
                      "friend_source_flags": [{ "type": "string" }, { "type": "empty" }],
                      "guild_positions": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "inline_attachment_media": [{ "type": "boolean" }, { "type": "empty" }],
                      "inline_embed_media": [{ "type": "boolean" }, { "type": "empty" }],
                      "gif_auto_play": [{ "type": "boolean" }, { "type": "empty" }],
                      "locale": [{ "type": "string" }, { "type": "empty" }],
                      "message_display_compact": [{ "type": "boolean" }, { "type": "empty" }],
                      "render_embeds": [{ "type": "boolean" }, { "type": "empty" }],
                      "render_reactions": [{ "type": "boolean" }, { "type": "empty" }],
                      "animate_emoji": [{ "type": "boolean" }, { "type": "empty" }],
                      "restricted_guilds": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "show_current_game": [{ "type": "boolean" }, { "type": "empty" }],
                      "theme": [{ "type": "string" }, { "type": "empty" }],
                      "detect_platform_accounts": [{ "type": "boolean" }, { "type": "empty" }],
                      "status": [{ "type": "string" }, { "type": "empty" }],
                      "default_guilds_restricted": [{ "type": "boolean" }, { "type": "empty" }],
                      "explicit_content_filter": [{ "type": "string" }, { "type": "empty" }],
                      "afk_timeout": [{ "type": "string" }, { "type": "empty" }],
                      "timezone_offset": [{ "type": "string" }, { "type": "empty" }],
                      "disable_games_tab": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_server_folders": [{ "type": "string" }, { "type": "empty" }],
                      "stream_notifications_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "allow_accessibility_detection": [{ "type": "boolean" }, { "type": "empty" }],
                      "contact_sync_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "native_phone_integration_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "animate_stickers": [{ "type": "string" }, { "type": "empty" }],
                      "channel_name": [{ "type": "string" }, { "type": "empty" }],
                      "is_nsfw": [{ "type": "boolean" }, { "type": "empty" }],
                      "update_type": [{ "type": "string" }, { "type": "empty" }],
                      "fields_updated": [{ "type": "array", "anyOf": [{ "type": "string" }] }, { "type": "empty" }],
                      "mute": [{ "type": "boolean" }, { "type": "empty" }],
                      "deaf": [{ "type": "boolean" }, { "type": "empty" }],
                      "old_roles": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "new_roles": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "old_nickname": [{ "type": "string" }, { "type": "empty" }],
                      "new_nickname": [{ "type": "string" }, { "type": "empty" }],
                      "is_initiator": [{ "type": "boolean" }, { "type": "empty" }],
                      "mutual_guilds": [{ "type": "string" }, { "type": "empty" }],
                      "target_role_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "permissions_allow": [{ "type": "string" }, { "type": "empty" }],
                      "permissions_deny": [{ "type": "string" }, { "type": "empty" }],
                      "animated": [{ "type": "boolean" }, { "type": "empty" }],
                      "name": [{ "type": "string" }, { "type": "empty" }],
                      "bucket": [{ "type": "string" }, { "type": "empty" }],
                      "revision": [{ "type": "string" }, { "type": "empty" }],
                      "population": [{ "type": "string" }, { "type": "empty" }],
                      "is_new_user": [{ "type": "boolean" }, { "type": "empty" }],
                      "session": [{ "type": "string" }, { "type": "empty" }],
                      "voice_state_count": [{ "type": "string" }, { "type": "empty" }],
                      "video_stream_count": [{ "type": "string" }, { "type": "empty" }],
                      "video_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "custom_status_count": [{ "type": "string" }, { "type": "empty" }],
                      "resolved": [{ "type": "boolean" }, { "type": "empty" }],
                      "code": [{ "type": "string" }, { "type": "empty" }],
                      "authenticated": [{ "type": "boolean" }, { "type": "empty" }],
                      "size_total": [{ "type": "string" }, { "type": "empty" }],
                      "size_online": [{ "type": "string" }, { "type": "empty" }],
                      "invite_type": [{ "type": "string" }, { "type": "empty" }],
                      "game_platform": [{ "type": "string" }, { "type": "empty" }],
                      "total_voice_state_count": [{ "type": "string" }, { "type": "empty" }],
                      "max_speaker_count": [{ "type": "string" }, { "type": "empty" }],
                      "total_speaker_count": [{ "type": "string" }, { "type": "empty" }],
                      "max_listener_count": [{ "type": "string" }, { "type": "empty" }],
                      "total_listener_count": [{ "type": "string" }, { "type": "empty" }],
                      "transport": [{ "type": "string" }, { "type": "empty" }],
                      "invite_code": [{ "type": "string" }, { "type": "empty" }],
                      "invite_guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "invite_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "invite_channel_type": [{ "type": "string" }, { "type": "empty" }],
                      "is_suggested": [{ "type": "boolean" }, { "type": "empty" }],
                      "row_num": [{ "type": "string" }, { "type": "empty" }],
                      "num_total": [{ "type": "string" }, { "type": "empty" }],
                      "is_filtered": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_affinity_connections": [{ "type": "string" }, { "type": "empty" }],
                      "send_type": [{ "type": "string" }, { "type": "empty" }],
                      "application_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "harvest_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "custom": [{ "type": "boolean" }, { "type": "empty" }],
                      "guild": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "invite": [{ "type": "string" }, { "type": "empty" }],
                      "user_day": [{ "type": "string" }, { "type": "empty" }],
                      "guild_verification_level": [{ "type": "string" }, { "type": "empty" }],
                      "temporary": [{ "type": "boolean" }, { "type": "empty" }],
                      "max_uses": [{ "type": "string" }, { "type": "empty" }],
                      "max_age": [{ "type": "string" }, { "type": "empty" }],
                      "regenerate": [{ "type": "boolean" }, { "type": "empty" }],
                      "unique": [{ "type": "boolean" }, { "type": "empty" }],
                      "action": [{ "type": "string" }, { "type": "empty" }],
                      "role_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "role_permissions": [{ "type": "string" }, { "type": "empty" }],
                      "role_mentionable": [{ "type": "boolean" }, { "type": "empty" }],
                      "role_hoist": [{ "type": "boolean" }, { "type": "empty" }],
                      "emoji_name": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "num_users_visible": [{ "type": "string" }, { "type": "empty" }],
                      "num_users_visible_with_mobile_indicator": [{ "type": "string" }, { "type": "empty" }],
                      "change_log_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "lang": "en" }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "seconds_open": [{ "type": "number" }, { "type": "empty" }],
                      "max_scrolled_percentage": [{ "type": "number" }, { "type": "empty" }],
                      "guild_suppress_everyone": [{ "type": "boolean" }, { "type": "empty" }],
                      "guild_is_muted": [{ "type": "boolean" }, { "type": "empty" }],
                      "guild_receive_mobile_push": [{ "type": "boolean" }, { "type": "empty" }],
                      "guild_message_notification_settings": [{ "type": "string" }, { "type": "empty" }],
                      "guild_suppress_roles": [{ "type": "boolean" }, { "type": "empty" }],
                      "parent_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "channel_is_overridden": [{ "type": "boolean" }, { "type": "empty" }],
                      "channel_is_muted": [{ "type": "boolean" }, { "type": "empty" }],
                      "channel_message_notification_settings": [{ "type": "string" }, { "type": "empty" }],
                      "num_users_visible_with_game_activity": [{ "type": "string" }, { "type": "empty" }],
                      "num_users_visible_with_activity": [{ "type": "string" }, { "type": "empty" }],
                      "notice_type": [{ "type": "string" }, { "type": "empty" }],
                      "registration_source": [{ "type": "string" }, { "type": "empty" }],
                      "full": [{ "type": "boolean" }, { "type": "empty" }],
                      "instant_invite": [{ "type": "boolean" }, { "type": "empty" }],
                      "solved_captcha": [{ "type": "boolean" }, { "type": "empty" }],
                      "card_index": [{ "type": "string" }, { "type": "empty" }],
                      "width": [{ "type": "string" }, { "type": "empty" }],
                      "tab": [{ "type": "string" }, { "type": "empty" }],
                      "load_time": [{ "type": "string" }, { "type": "empty" }],
                      "shortcut_name": [{ "type": "string" }, { "type": "empty" }],
                      "source_class_list": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "num_guilds": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_recommended": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_popular": [{ "type": "string" }, { "type": "empty" }],
                      "recommended_guild_ids": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "category_id": [{ "type": "string" }, { "type": "empty" }],
                      "screen_name": [{ "type": "string" }, { "type": "empty" }],
                      "duration_ms_since_app_opened": [{ "type": "string" }, { "type": "empty" }],
                      "total_compressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "total_uncompressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "total_transfer_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "js_compressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "js_uncompressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "js_transfer_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "css_compressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "css_uncompressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "css_transfer_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "autocomplete_type": [{ "type": "string" }, { "type": "empty" }],
                      "application_ids_viewed": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "sku_ids_viewed": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "is_pending": [{ "type": "boolean" }, { "type": "empty" }],
                      "preview_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "discord_ai_spam_likelihood": [{ "type": "number" }, { "type": "empty" }],
                      "discord_ai_model_version": [{ "type": "string" }, { "type": "empty" }],
                      "search_type": [{ "type": "string" }, { "type": "empty" }],
                      "num_modifiers": [{ "type": "string" }, { "type": "empty" }],
                      "prev_search_id": [{ "type": "string" }, { "type": "empty" }],
                      "is_animated": [{ "type": "boolean" }, { "type": "empty" }],
                      "is_external": [{ "type": "boolean" }, { "type": "empty" }],
                      "has_search_query": [{ "type": "boolean" }, { "type": "empty" }],
                      "duration_ms_since_connection_start": [{ "type": "string" }, { "type": "empty" }],
                      "duration_ms_since_identify_start": [{ "type": "string" }, { "type": "empty" }],
                      "duration_ms_since_emit_start": [{ "type": "string" }, { "type": "empty" }],
                      "compressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "uncompressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "identify_total_server_duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "identify_api_duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "identify_guilds_duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "compression_algorithm": [{ "type": "string" }, { "type": "empty" }],
                      "packing_algorithm": [{ "type": "string" }, { "type": "empty" }],
                      "unpack_duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "is_reconnect": [{ "type": "boolean" }, { "type": "empty" }],
                      "is_fast_connect": [{ "type": "boolean" }, { "type": "empty" }],
                      "presences_size": [{ "type": "string" }, { "type": "empty" }],
                      "read_states_size": [{ "type": "string" }, { "type": "empty" }],
                      "private_channels_size": [{ "type": "string" }, { "type": "empty" }],
                      "user_guild_settings_size": [{ "type": "string" }, { "type": "empty" }],
                      "relationships_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_voice_states_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_channels_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_members_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_presences_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_roles_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_emojis_size": [{ "type": "string" }, { "type": "empty" }],
                      "guild_remaining_data_size": [{ "type": "string" }, { "type": "empty" }],
                      "num_guild_channels": [{ "type": "string" }, { "type": "empty" }],
                      "num_guild_category_channels": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_with_changed_metadata": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_with_changed_channels": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_with_changed_roles": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_with_changed_emojis": [{ "type": "string" }, { "type": "empty" }],
                      "num_changed_channels": [{ "type": "string" }, { "type": "empty" }],
                      "num_changed_roles": [{ "type": "string" }, { "type": "empty" }],
                      "num_changed_emojis": [{ "type": "string" }, { "type": "empty" }],
                      "had_any_guild_in_store": [{ "type": "boolean" }, { "type": "empty" }],
                      "identify_compressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "identify_uncompressed_byte_size": [{ "type": "string" }, { "type": "empty" }],
                      "did_force_clear_guild_hashes": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_guilds_with_metadata_omitted": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_with_channels_omitted": [{ "type": "string" }, { "type": "empty" }],
                      "num_guilds_with_roles_omitted": [{ "type": "string" }, { "type": "empty" }],
                      "users_size": [{ "type": "string" }, { "type": "empty" }],
                      "wave": [{ "type": "string" }, { "type": "empty" }],
                      "cpu_brand": [{ "type": "string" }, { "type": "empty" }],
                      "cpu_vendor": [{ "type": "string" }, { "type": "empty" }],
                      "cpu_memory": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 1 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "gpu_brand": [{ "type": "string" }, { "type": "empty" }],
                      "gpu_memory": [{ "type": "string" }, { "type": "empty" }],
                      "batteries": [{ "type": "string" }, { "type": "empty" }],
                      "display_monitors": [{ "type": "string" }, { "type": "empty" }],
                      "display_primary_width": [{ "type": "string" }, { "type": "empty" }],
                      "display_primary_height": [{ "type": "string" }, { "type": "empty" }],
                      "display_desktop_width": [{ "type": "string" }, { "type": "empty" }],
                      "display_desktop_height": [{ "type": "string" }, { "type": "empty" }],
                      "gpu_count": [{ "type": "string" }, { "type": "empty" }],
                      "load_duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "offset": [{ "type": "string" }, { "type": "empty" }],
                      "page": [{ "type": "string" }, { "type": "empty" }],
                      "total_results": [{ "type": "string" }, { "type": "empty" }],
                      "page_results": [{ "type": "string" }, { "type": "empty" }],
                      "guild_ids": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "search_id": [{ "type": "string" }, { "type": "empty" }],
                      "is_error": [{ "type": "boolean" }, { "type": "empty" }],
                      "limit": [{ "type": "string" }, { "type": "empty" }],
                      "is_indexing": [{ "type": "boolean" }, { "type": "empty" }],
                      "page_num_messages": [{ "type": "string" }, { "type": "empty" }],
                      "page_num_links": [{ "type": "string" }, { "type": "empty" }],
                      "page_num_embeds": [{ "type": "string" }, { "type": "empty" }],
                      "page_num_attach": [{ "type": "string" }, { "type": "empty" }],
                      "query": [{ "type": "string" }, { "type": "empty" }],
                      "is_user_set_discriminator": [{ "type": "boolean" }, { "type": "empty" }],
                      "template_name": [{ "type": "string" }, { "type": "empty" }],
                      "template_code": [{ "type": "string" }, { "type": "empty" }],
                      "source_page": [{ "type": "string" }, { "type": "empty" }],
                      "source_section": [{ "type": "string" }, { "type": "empty" }],
                      "source_object": [{ "type": "string" }, { "type": "empty" }],
                      "rating": [{ "type": "string" }, { "type": "empty" }],
                      "input_device_name": [{ "type": "string" }, { "type": "empty" }],
                      "output_device_name": [{ "type": "string" }, { "type": "empty" }],
                      "video_device_name": [{ "type": "string" }, { "type": "empty" }],
                      "automatic": [{ "type": "boolean" }, { "type": "empty" }],
                      "enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "notif_type": [{ "type": "string" }, { "type": "empty" }],
                      "platform_type": [{ "type": "string" }, { "type": "empty" }],
                      "connect_time": [{ "type": "string" }, { "type": "empty" }],
                      "audio_subsystem": [{ "type": "string" }, { "type": "empty" }],
                      "audio_layer": [{ "type": "string" }, { "type": "empty" }],
                      "settings_type": [{ "type": "string" }, { "type": "empty" }],
                      "destination_pane": [{ "type": "string" }, { "type": "empty" }],
                      "origin_pane": [{ "type": "string" }, { "type": "empty" }],
                      "flow_type": [{ "type": "string" }, { "type": "empty" }],
                      "from_step": [{ "type": "string" }, { "type": "empty" }],
                      "to_step": [{ "type": "string" }, { "type": "empty" }],
                      "seconds_on_from_step": [{ "type": "number" }, { "type": "empty" }],
                      "acknowledged": [{ "type": "boolean" }, { "type": "empty" }],
                      "tutorial": [{ "type": "string" }, { "type": "empty" }],
                      "new_sort_type": [{ "type": "string" }, { "type": "empty" }],
                      "num_roles": [{ "type": "string" }, { "type": "empty" }],
                      "index_num": [{ "type": "string" }, { "type": "empty" }],
                      "num_failed": [{ "type": "string" }, { "type": "empty" }],
                      "num_delta_installed": [{ "type": "string" }, { "type": "empty" }],
                      "num_full_installed": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_total": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_total": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_total": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_total": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_total": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_total": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_game_utils": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_game_utils": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_game_utils": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_game_utils": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_game_utils": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_media": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_media": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_media": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_media": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_cloudsync": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_modules": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_overlay2": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_rpc": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_cloudsync": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_modules": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_overlay2": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_rpc": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_cloudsync": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_game_utils": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_modules": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_overlay2": [{ "type": "string" }, { "type": "empty" }],
                      "background_install_ms_discord_rpc": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_cloudsync": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_modules": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_overlay2": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_rpc": [{ "type": "string" }, { "type": "empty" }],
                      "background_bytes_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "background_download_ms_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_desktop_core": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_voice": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_overlay2": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_overlay2": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_krisp": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_utils": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_utils": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_utils": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_utils": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_utils": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_erlpack": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_spellcheck": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_erlpack": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_spellcheck": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_erlpack": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_spellcheck": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_erlpack": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_spellcheck": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_erlpack": [{ "type": "string" }, { "type": "empty" }],
                      "max_version_discord_spellcheck": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_bytes_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_download_ms_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "foreground_install_ms_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "min_version_discord_dispatch": [{ "type": "string" }, { "type": "empty" }],
                      "is_community": [{ "type": "boolean" }, { "type": "empty" }],
                      "skipped": [{ "type": "boolean" }, { "type": "empty" }],
                      "tab_opened": [{ "type": "string" }, { "type": "empty" }],
                      "device_from_name": [{ "type": "string" }, { "type": "empty" }],
                      "device_to_name": [{ "type": "string" }, { "type": "empty" }],
                      "device_type": [{ "type": "string" }, { "type": "empty" }],
                      "device_is_certified": [{ "type": "boolean" }, { "type": "empty" }],
                      "previous_action": [{ "type": "string" }, { "type": "empty" }],
                      "email_type": [{ "type": "string" }, { "type": "empty" }],
                      "email_id": [{ "type": "string" }, { "type": "empty" }],
                      "email_domain": [{ "type": "string" }, { "type": "empty" }],
                      "guild_ids_viewed": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "device_name": [{ "type": "string" }, { "type": "empty" }],
                      "source": [{ "type": "string" }, { "type": "empty" }],
                      "location_object_type": [{ "type": "string" }, { "type": "empty" }],
                      "login_source": [{ "type": "string" }, { "type": "empty" }],
                      "setup_type": [{ "type": "string" }, { "type": "empty" }],
                      "has_e_mail": [{ "type": "boolean" }, { "type": "empty" }],
                      "platform": [{ "type": "string" }, { "type": "empty" }],
                      "ptb": [{ "type": "boolean" }, { "type": "empty" }],
                      "referring_location": [{ "type": "string" }, { "type": "empty" }],
                      "released": [{ "type": "boolean" }, { "type": "empty" }]
                    }
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "timestamp"],
              "arguments": { "lang": "en" },
              "template": ["data"]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "event_type": [{ "type": "string" }],
                      "event_id": [{ "type": "string" }],
                      "event_source": [{ "type": "string" }],
                      "user_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        }
                      ],
                      "domain": [{ "type": "string" }],
                      "freight_hostname": [{ "type": "string" }],
                      "ip": [{ "type": "string" }],
                      "day": [{ "type": "string" }],
                      "chosen_locale": [{ "type": "string" }],
                      "detected_locale": [{ "type": "string" }],
                      "user_is_authenticated": [{ "type": "boolean" }],
                      "browser": [{ "type": "string" }],
                      "cfduid": [{ "type": "string" }, { "type": "empty" }],
                      "os": [{ "type": "string" }],
                      "os_version": [{ "type": "string" }],
                      "os_arch": [{ "type": "string" }, { "type": "empty" }],
                      "client_build_number": [{ "type": "string" }],
                      "release_channel": [{ "type": "string" }],
                      "client_version": [{ "type": "string" }, { "type": "empty" }],
                      "city": [{ "type": "string" }],
                      "country_code": [{ "type": "string" }],
                      "region_code": [{ "type": "string" }],
                      "time_zone": [{ "type": "string" }],
                      "isp": [{ "type": "string" }],
                      "message_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "channel": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "channel_type": [{ "type": "string" }, { "type": "empty" }],
                      "is_friend": [{ "type": "boolean" }, { "type": "empty" }],
                      "private": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_attachments": [{ "type": "string" }, { "type": "empty" }],
                      "max_attachment_size": [{ "type": "string" }, { "type": "empty" }],
                      "length": [{ "type": "string" }, { "type": "empty" }],
                      "word_count": [{ "type": "string" }, { "type": "empty" }],
                      "mention_everyone": [{ "type": "boolean" }, { "type": "empty" }],
                      "emoji_unicode": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_custom": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_custom_external": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_managed": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_managed_external": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_animated": [{ "type": "string" }, { "type": "empty" }],
                      "emoji_only": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_embeds": [{ "type": "string" }, { "type": "empty" }],
                      "attachment_ids": [
                        {
                          "type": "array",
                          "anyOf": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        },
                        { "type": "empty" }
                      ],
                      "has_spoiler": [{ "type": "boolean" }, { "type": "empty" }],
                      "probably_has_markdown": [{ "type": "boolean" }, { "type": "empty" }],
                      "user_is_bot": [{ "type": "boolean" }, { "type": "empty" }],
                      "sticker_ids": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "client_send_timestamp": [{ "type": "string" }],
                      "client_track_timestamp": [{ "type": "string" }],
                      "timestamp": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "lang": "en" }
                          }
                        }
                      ],
                      "channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "old_nsfw": [{ "type": "boolean" }, { "type": "empty" }],
                      "new_nsfw": [{ "type": "boolean" }, { "type": "empty" }],
                      "system_locale": [{ "type": "string" }, { "type": "empty" }],
                      "client_performance_cpu": [{ "type": "number" }, { "type": "empty" }],
                      "client_performance_memory": [{ "type": "string" }, { "type": "empty" }],
                      "type": [{ "type": "string" }, { "type": "empty" }],
                      "accessibility_support_enabled": [{ "type": "boolean" }, { "type": "empty" }],
                      "accessibility_features": [{ "type": "string" }, { "type": "empty" }],
                      "has_images": [{ "type": "boolean" }, { "type": "empty" }],
                      "profile_user_status": [{ "type": "string" }, { "type": "empty" }],
                      "is_streaming": [{ "type": "boolean" }, { "type": "empty" }],
                      "has_custom_status": [{ "type": "boolean" }, { "type": "empty" }],
                      "location_section": [{ "type": "string" }, { "type": "empty" }],
                      "location_object": [{ "type": "string" }, { "type": "empty" }],
                      "browser_user_agent": [{ "type": "string" }, { "type": "empty" }],
                      "browser_version": [{ "type": "string" }, { "type": "empty" }],
                      "location": [{ "type": "string" }, { "type": "empty" }],
                      "referrer": [{ "type": "string" }, { "type": "empty" }],
                      "referring_domain": [{ "type": "string" }, { "type": "empty" }],
                      "session": [{ "type": "string" }, { "type": "empty" }],
                      "application_name": [{ "type": "string" }, { "type": "empty" }],
                      "game_platform": [{ "type": "string" }, { "type": "empty" }],
                      "application_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "load_id": [{ "type": "string" }, { "type": "empty" }],
                      "application_ids_viewed": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "sku_ids_viewed": [{ "type": "array", "anyOf": [] }, { "type": "empty" }],
                      "duration_ms": [{ "type": "string" }, { "type": "empty" }],
                      "join_method": [{ "type": "string" }, { "type": "empty" }],
                      "user_guilds": [{ "type": "string" }, { "type": "empty" }],
                      "join_type": [{ "type": "string" }, { "type": "empty" }],
                      "location_guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "location_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "location_channel_type": [{ "type": "string" }, { "type": "empty" }],
                      "harvest_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "guild_size_total": [{ "type": "string" }, { "type": "empty" }],
                      "guild_member_num_roles": [{ "type": "string" }, { "type": "empty" }],
                      "guild_member_perms": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 1000 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "guild_num_channels": [{ "type": "string" }, { "type": "empty" }],
                      "guild_num_text_channels": [{ "type": "string" }, { "type": "empty" }],
                      "guild_num_voice_channels": [{ "type": "string" }, { "type": "empty" }],
                      "guild_num_roles": [{ "type": "string" }, { "type": "empty" }],
                      "guild_is_vip": [{ "type": "boolean" }, { "type": "empty" }],
                      "is_member": [{ "type": "boolean" }, { "type": "empty" }],
                      "num_voice_channels_active": [{ "type": "string" }, { "type": "empty" }],
                      "channel_size_total": [{ "type": "string" }, { "type": "empty" }],
                      "channel_member_perms": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 1000 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "channel_hidden": [{ "type": "boolean" }, { "type": "empty" }],
                      "server": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "message_type": [{ "type": "string" }, { "type": "empty" }],
                      "location_page": [{ "type": "string" }, { "type": "empty" }],
                      "sku_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "subscription_plan_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "payment_type": [{ "type": "string" }, { "type": "empty" }],
                      "quantity": [{ "type": "string" }, { "type": "empty" }],
                      "location_object_type": [{ "type": "string" }, { "type": "empty" }],
                      "source_page": [{ "type": "string" }, { "type": "empty" }],
                      "source_section": [{ "type": "string" }, { "type": "empty" }],
                      "source_object": [{ "type": "string" }, { "type": "empty" }],
                      "login_source": [{ "type": "string" }, { "type": "empty" }],
                      "is_new_user": [{ "type": "boolean" }, { "type": "empty" }],
                      "guild_template_code": [{ "type": "string" }, { "type": "empty" }],
                      "guild_template_name": [{ "type": "string" }, { "type": "empty" }],
                      "guild_template_guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "source": [{ "type": "string" }, { "type": "empty" }],
                      "device_name": [{ "type": "string" }, { "type": "empty" }],
                      "party_platform": [{ "type": "string" }, { "type": "empty" }],
                      "registration_source": [{ "type": "string" }, { "type": "empty" }],
                      "full": [{ "type": "boolean" }, { "type": "empty" }],
                      "instant_invite": [{ "type": "boolean" }, { "type": "empty" }],
                      "invite_code": [{ "type": "string" }, { "type": "empty" }],
                      "invite_guild_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "invite_channel_id": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "invite_channel_type": [{ "type": "string" }, { "type": "empty" }],
                      "solved_captcha": [{ "type": "boolean" }, { "type": "empty" }],
                      "custom": [{ "type": "boolean" }, { "type": "empty" }],
                      "guild": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "factor": 0.000001 }
                          }
                        },
                        { "type": "empty" }
                      ],
                      "invite": [{ "type": "string" }, { "type": "empty" }],
                      "user_day": [{ "type": "string" }, { "type": "empty" }],
                      "size_total": [{ "type": "string" }, { "type": "empty" }],
                      "size_online": [{ "type": "string" }, { "type": "empty" }],
                      "invite_type": [{ "type": "string" }, { "type": "empty" }],
                      "guild_verification_level": [{ "type": "string" }, { "type": "empty" }]
                    }
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [
        {
          "path": ["data"],
          "category": "Activity",
          "subcategory": [{ "type": "data", "value": ["labelFileName"] }],
          "content": [{ "type": "data", "value": ["data", null] }],
          "selectedTimestamps": [
            {
              "path": ["data", null, "timestamp"],
              "arguments": { "lang": "en" },
              "template": ["data"]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "factor": 0.000001 }
                }
              }
            ],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "type": [{ "type": "number" }],
                          "id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "name": [{ "type": "string" }],
                          "avatar": [{ "type": "empty" }],
                          "channel_id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "guild_id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "application_id": [{ "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "factor": 0.000001 }
                }
              }
            ],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "type": [{ "type": "number" }],
                          "name": [{ "type": "string" }],
                          "position": [{ "type": "number" }, { "type": "empty" }],
                          "parent_id": [
                            { "type": "empty" },
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "permission_overwrites": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "id": [
                                      {
                                        "type": "string",
                                        "supposedUsage": {
                                          "format": "time",
                                          "argument": { "factor": 0.000001 }
                                        }
                                      }
                                    ],
                                    "type": [{ "type": "number" }, { "type": "empty" }],
                                    "allow": [{ "type": "string" }],
                                    "deny": [{ "type": "string" }]
                                  }
                                }
                              ]
                            }
                          ],
                          "nsfw": [{ "type": "boolean" }],
                          "last_message_id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            },
                            { "type": "empty" }
                          ],
                          "topic": [{ "type": "empty" }, { "type": "string" }],
                          "rate_limit_per_user": [{ "type": "number" }, { "type": "empty" }],
                          "bitrate": [{ "type": "number" }, { "type": "empty" }],
                          "user_limit": [{ "type": "number" }, { "type": "empty" }],
                          "rtc_region": [{ "type": "empty" }]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "factor": 0.000001 }
                }
              }
            ],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "user_id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "action_type": [{ "type": "number" }],
                          "changes": [
                            {
                              "type": "array",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "key": [{ "type": "string" }],
                                    "new_value": [
                                      {
                                        "type": "array",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "name": [{ "type": "string" }],
                                              "id": [
                                                {
                                                  "type": "string",
                                                  "supposedUsage": {
                                                    "format": "time",
                                                    "argument": {
                                                      "factor": 0.000001
                                                    }
                                                  }
                                                }
                                              ]
                                            }
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "factor": 0.000001 }
                }
              }
            ],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "array",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "name": [{ "type": "string" }],
                          "roles": [{ "type": "array", "anyOf": [] }],
                          "id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ],
                          "require_colons": [{ "type": "boolean" }],
                          "managed": [{ "type": "boolean" }],
                          "animated": [{ "type": "boolean" }],
                          "available": [{ "type": "boolean" }],
                          "user_id": [
                            {
                              "type": "string",
                              "supposedUsage": {
                                "format": "time",
                                "argument": { "factor": 0.000001 }
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "object",
          "properties": {
            "labelFileName": [{ "type": "string" }],
            "labelFilePath": [{ "type": "string", "supposedUsage": { "format": "uri" } }],
            "labelParentFolderName": [{ "type": "string" }],
            "labelDate": [
              {
                "type": "string",
                "supposedUsage": {
                  "format": "time",
                  "argument": { "iso": true }
                }
              }
            ],
            "data": [
              {
                "type": "array",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "508357248330760243": [{ "type": "string" }],
                      "691614385432428586": [{ "type": "string" }],
                      "741879515013316629": [
                        {
                          "type": "string",
                          "supposedUsage": {
                            "format": "time",
                            "argument": { "iso": true }
                          }
                        }
                      ],
                      "824679324392095754": [{ "type": "string" }]
                    }
                  }
                ]
              }
            ]
          }
        }
      ],
      "templates": [],
      "hidden": false
    }
  ],
  "fileStructure": [
    "account/",
    "activities_e",
    "activities_w",
    "activity/",
    "messages/",
    "programs/",
    "servers/",
    "README.txt"
  ],
  "optionalFileStructure": ["activities_e", "activities_w", "programs"]
}
